import React from 'react';
const Button = (props) => {
    return (
        <div className={`${props.className}`} style={props.extraStyle} onClick={props.onClick}>
            {props.text}
        </div>
    )
}
export default Button;